import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Input } from '../../../common/html/input'
import { checkEmailValid, checkPhoneValid } from '../../../helpers/validation'
import { PAYMENT_METHOD } from '../../constant'
import classes from '../../index.module.scss'
import {
  changeUserInformation,
  selectUserInformationValue,
} from '../../store/slice'

const InputInformation = ({ keyInput, placeHolder, onChange, isValid }) => {
  const value = useSelector(selectUserInformationValue(keyInput))
  const textPlaceHolder = UseI18n(placeHolder)

  const changeInput = (e) => {
    onChange({ key: keyInput, value: e.target.value })
  }

  return (
    <Input
      noControl
      classNameInput={classes.input}
      style={{
        borderStyle: 'solid',
        borderWidth: ' 1px',
        borderColor: '#E0E0E0',
      }}
      containerStyle={{
        marginBottom: !isValid ? 30 : 20,
      }}
      placeHolder={textPlaceHolder}
      isShowIcon={false}
      value={value || ''}
      isShowLabel
      onChange={changeInput}
      isValid={isValid}
      textInvalid={
        keyInput === 'invoiceReceivingEmail' && !!value
          ? 'cartAndOrders.message.m01'
          : 'cartAndOrders.message.m03'
      }
    />
  )
}

const UserInformation = ({ method, isValid, setIsValid }) => {
  const dispatch = useDispatch()

  const informationInputs = [
    {
      key: 'customerName',
      placeHolder: 'cartAndOrders.orderInformation.customerName',
    },
    {
      key: 'companyName',
      placeHolder: 'cartAndOrders.orderInformation.companyName',
    },
    {
      key: 'companyAddress',
      placeHolder: 'cartAndOrders.orderInformation.companyAddress',
    },
    {
      key: 'taxCode',
      placeHolder: 'cartAndOrders.orderInformation.taxCode',
    },
    {
      key: 'invoiceReceivingEmail',
      placeHolder: 'cartAndOrders.orderInformation.invoiceEmail',
    },
    {
      key: 'phone',
      placeHolder: 'cartAndOrders.orderInformation.phone',
    },
  ]

  const onChange = ({ key, value: eventValue }) => {
    if (!!eventValue.trim()) {
      setIsValid({
        ...isValid,
        [key]: true,
      })
    }
    if (key === 'phone') {
      if (!!eventValue.trim()) {
        if (!checkPhoneValid(eventValue, false)) {
          return
        }
      }
    }

    if (key === 'invoiceReceivingEmail') {
      if (!!eventValue.trim()) {
        setIsValid({
          ...isValid,
          invoiceReceivingEmail: checkEmailValid(eventValue),
        })
      } else {
        setIsValid({
          ...isValid,
          invoiceReceivingEmail: true,
        })
      }
    }
    dispatch(changeUserInformation({ key, value: eventValue }))
  }

  return (
    <>
      {method !== PAYMENT_METHOD.PACKAGE && (
        <>
          <Element
            className={classes.userInformationContainer}
            style={{
              borderTop: '5px solid #FFFFFF',
            }}
          >
            <Element
              className="fw600"
              style={{ fontSize: 14, paddingBottom: 14 }}
            >
              <Translate value="cartAndOrders.orderInformation.titleInvoice" />
            </Element>
            {informationInputs.map(({ key, placeHolder }) => {
              return (
                <InputInformation
                  key={key}
                  keyInput={key}
                  placeHolder={placeHolder}
                  onChange={onChange}
                  isValid={isValid[key]}
                />
              )
            })}

            <Element
              className={`mt2 ${classes.note}`}
              style={{ backgroundColor: '#F8E7E9' }}
            >
              <i>
                <Translate value="cartAndOrders.orderInformation.note" />
              </i>
            </Element>
          </Element>
        </>
      )}
    </>
  )
}

export default UserInformation
